import React from "react";

class ColumnWrap extends React.Component {
    static defaultProps = {
        style: {}
    };

    render() {
        return (
            <div className="columns is-centered">
                <div className={`column ${this.props.column || ""}`} style={{ textAlign: this.props.center ? "center" : "inherit", ...this.props.style }}>
                    {this.props.children}
                </div>
            </div>
        )
    }
}

export default ColumnWrap;